import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsGeneralReportToolbarComponent } from './fields-general-report-toolbar.component';
import {
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxListModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxToolbarModule
} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsGeneralReportToolbarComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxLoadPanelModule,
    DxDropDownBoxModule,
    DxListModule
  ],
  exports: [FieldsGeneralReportToolbarComponent]
})
export class FieldsGeneralReportToolbarModule { }
